/* eslint-disable  */
//@ts-nocheck
import { useMemo, useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { GET_INFLUENCER_CLASSES } from '../../../api/graphql/query';
import auth from '../../auth';
import { Class } from 'generated/graphql';
import { rrulestr } from 'rrule';
import { isAfter } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useModal } from '../../common/Modal';
import { ADD_CLASS } from '../../../api/graphql/mutation';
import { Button } from '../../common/inputs/Button';
import { EditForm } from './EditFormModal';
import { AugmentedClass } from './types';
import { Table } from './Table';
import { formDataToMutationData } from './utils';
import Spinner from '@client/components/Spinner';

const Filter = ({
  value,
  onChange,
}: {
  value: 'upcoming' | 'past';
  onChange: (val: 'upcoming' | 'past') => any;
}) => {
  const itemStyles = 'rounded-full px-4 py-[4px] cursor-pointer font-semibold';
  const activeStyles = itemStyles + ' bg-[#151E34] text-white';
  return (
    <div className="flex space-x-3">
      <div
        className={value === 'upcoming' ? activeStyles : itemStyles}
        onClick={() => onChange('upcoming')}
      >
        Upcoming
      </div>
      <div
        className={value === 'past' ? activeStyles : itemStyles}
        onClick={() => onChange('past')}
      >
        Past
      </div>
    </div>
  );
};

const AddClassButton = ({ onNewClass, influencerId }) => {
  const [addClass, {}] = useMutation(ADD_CLASS);
  const editModal = useModal(EditForm);

  return (
    <>
      <div className="mt-[-80px] h-[80px] mr-[-20px] flex justify-end items-start">
        <Button onClick={() => editModal.open()}>
          <FontAwesomeIcon
            icon={faPlus}
            className="leading-none text-white text-xs mr-3"
          />
          New Class
        </Button>
      </div>
      <editModal.Popup
        initialData={undefined}
        isEdit={false}
        influencerId={influencerId}
        onSubmit={(data) =>
          addClass({
            variables: { data: formDataToMutationData(influencerId, data) },
          }).then(() => onNewClass())
        }
      />
    </>
  );
};

export const LiveClassesTab = ({ influencerId }: { influencerId: number }) => {
  const [filter, setFilter] = useState<'upcoming' | 'past'>('upcoming');

  const { data, loading, error, refetch } = useQuery(GET_INFLUENCER_CLASSES, {
    variables: { influencerId },
  });

  const augmentedData = useMemo<AugmentedClass[]>(
    () =>
      data
        ? data.influencerClasses.map((x: Class) => {
            const parsedSchedule = rrulestr(x.schedule).options;
            return {
              ...x,
              dtstart: parsedSchedule.dtstart,
              isUpcoming: isAfter(parsedSchedule.dtstart, Date.now()),
            };
          })
        : [],
    [data],
  );

  const filteredAugmentedData = useMemo(
    () =>
      augmentedData.filter((x) =>
        filter === 'upcoming' ? x.isUpcoming : !x.isUpcoming,
      ),
    [augmentedData, filter],
  );

  return (
    <div>
      {loading ? <Spinner color="#6367ef" /> : null}
      <div className="text-red-500">{error?.message}</div>
      {!loading && !error ? (
        <>
          <AddClassButton onNewClass={refetch} {...{ influencerId }} />
          <Filter value={filter} onChange={(x) => setFilter(x)} />
          <div style={{ height: 17 }} />
          <Table
            onClassChange={refetch}
            classes={filteredAugmentedData}
            {...{ influencerId }}
          />
        </>
      ) : null}
    </div>
  );
};
